<template>
  <div class="wrapper">
    <el-dialog
      :title="rowId ? '编辑门店' : '新增门店'"
      :visible.sync="showAddOrEdit"
      width="900px"
      class="store-dialog"
      :before-close="cancelFun"
    >
      <div class="scroll-wrap">
        <el-form ref="form" :model="formData" class="store-form" label-width="130px">
          <!-- 基本信息区域 -->
          <div class="form-section">
            <div class="section-title">
              <i class="el-icon-shop"></i>
              <span>基本信息</span>
            </div>
            <div class="section-content">
              <el-form-item label="门店名称" prop="storeName" :rules="rules">
                <el-input
                    v-model="formData.storeName"
                    placeholder="请输入门店名称"
                    size="small"
                    class="form-input"
                ></el-input>
              </el-form-item>

              <el-form-item label="门店标签" prop="storeTagList">
                <div class="store-tags">
                  <el-tag
                      :key="tag"
                      v-for="tag in formData.storeTagList"
                      :disable-transitions="false"
                      closable
                      @close="handleCloseTag(tag)"
                      class="store-tag-item"
                  >
                    {{ tag }}
                  </el-tag>
                  <el-input
                      class="input-new-tag"
                      v-if="tagInputVisible"
                      v-model="tagInputValue"
                      ref="saveTagInput"
                      size="small"
                      @keyup.enter.native="handleTagInputConfirm"
                      @blur="handleTagInputConfirm"
                  >
                  </el-input>
                  <el-button
                      v-else
                      class="button-new-tag"
                      size="small"
                      @click="showTagInput"
                  >+ 新增标签</el-button>
                </div>
              </el-form-item>
            </div>
          </div>

          <!-- 负责人信息区域 -->
          <div class="form-section">
            <div class="section-title">
              <i class="el-icon-user"></i>
              <span>负责人信息</span>
            </div>
            <div class="section-content">
              <el-form-item label="负责人姓名" prop="legalName" :rules="rules">
                <el-input
                    v-model="formData.legalName"
                    placeholder="请输入负责人姓名"
                    size="small"
                    class="form-input"
                ></el-input>
              </el-form-item>

              <el-form-item label="手机号" prop="legalMobile" :rules="rules">
                <el-input
                    v-model="formData.legalMobile"
                    placeholder="请输入负责人手机号"
                    size="small"
                    class="form-input"
                ></el-input>
              </el-form-item>
            </div>
          </div>

          <!-- 证件信息区域 -->
          <div class="form-section">
            <div class="section-title">
              <i class="el-icon-picture"></i>
              <span>证件信息</span>
            </div>
            <div class="section-content">
              <el-form-item label="门头照片" prop="facadeImageList" :rules="rules">
                <FileUpload
                    :isMulti="true"
                    :name.sync="formData.facadeImageList"
                    :url="formData.facadeImageUrlList"
                ></FileUpload>
              </el-form-item>

              <el-form-item label="营业执照" prop="licenseImage">
                <FileUpload
                    :name.sync="formData.licenseImage"
                    :url="formData.licenseImageUrl"
                ></FileUpload>
              </el-form-item>
            </div>
          </div>

          <!-- 银行信息区域 -->
          <div class="form-section">
            <div class="section-title">
              <i class="el-icon-credit-card"></i>
              <span>银行信息</span>
            </div>
            <div class="section-content">
              <el-form-item label="开户行">
                <el-input
                    v-model="formData.bankName"
                    placeholder="请输入开户行（选填）"
                    size="small"
                    class="form-input"
                ></el-input>
              </el-form-item>

              <el-form-item label="银行卡号">
                <el-input
                    v-model="formData.bankCardNo"
                    placeholder="请输入银行卡号（选填）"
                    size="small"
                    class="form-input"
                ></el-input>
              </el-form-item>
            </div>
          </div>

          <!-- 地址信息区域 -->
          <div class="form-section">
            <div class="section-title">
              <i class="el-icon-location"></i>
              <span>地址信息</span>
            </div>
            <div class="section-content">
              <el-form-item label="所在地区" prop="regionIdList" :rules="districtRule">
                <AreaSelector
                    style="width: 400px"
                    size="small"
                    v-model="formData.regionIdList"
                />
              </el-form-item>

              <el-form-item label="详细地址" prop="addressDetail" :rules="rules">
                <el-input
                    type="textarea"
                    :rows="3"
                    v-model="formData.addressDetail"
                    placeholder="请输入详细地址"
                    class="form-textarea"
                ></el-input>
              </el-form-item>
            </div>
          </div>

          <!-- 其他信息区域 -->
          <div class="form-section">
            <div class="section-title">
              <i class="el-icon-setting"></i>
              <span>其他信息</span>
            </div>
            <div class="section-content">
              <el-form-item label="监管服务费" prop="lockAmount" :rules="rules">
                <el-input-number
                    v-model="formData.lockAmount"
                    :precision="2"
                    :step="0.01"
                    :min="0"
                    size="small"
                    class="form-input"
                    placeholder="请输入监管服务费"
                ></el-input-number>
              </el-form-item>

              <el-form-item label="门店BD" prop="businessUserId" :rules="rules">
                <SelectAdmin v-model="formData.businessUserId"></SelectAdmin>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelFun">取 消</el-button>
        <el-button type="primary" size="small" @click="submitFun">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getStoreDetailAPI, addStoreAPI, editStoreAPI } from "./api";
import FileUpload from "@/components/file-upload/index.vue";
import SelectAdmin from "@/views/components/select-admin.vue";
import AreaSelector from "@/components/area-selector/index.vue";

export default {
  name: "StoreAddOrEdit",

  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
  },

  components: {
    FileUpload,
    SelectAdmin,
    AreaSelector,
  },

  data() {
    return {
      dialogVisible: false,
      rules: [{ required: true, message: "该项不能为空", trigger: "blur" }],
      districtRule: [
        {
          validator: (rule, value, callback) => {
            if (!value || (Array.isArray(value) && value.length === 0)) {
              return callback(new Error("请选择地区"));
            }
            return callback();
          },
        },
      ],
      formData: {
        storeType: 2,
        storeName: "",
        storeTagList: [],
        legalName: "",
        legalMobile: "",
        licenseImage: "",
        facadeImageList: "",
        addressDetail: "",
        insuranceRate: 0,
        lockAmount: 0,
        businessUserId: "",
        bankName: "",
        bankCardNo: "",
        payeeIdName: "",
        settleType: 1,
        payeeAlipayAccount: "",
        regionIdList: [],
        capitalId: undefined,
      },
      tagInputVisible: false,
      tagInputValue: "",
    };
  },
  mounted() {
    if (this.rowId) {
      this.getStoreDetail();
    }
  },
  methods: {
    async getStoreDetail() {
      this.formData = await getStoreDetailAPI(this.rowId);
      if (this.formData.capitalId <= 0) this.formData.capitalId = undefined;
    },
    handleCloseTag(tag) {
      this.formData.storeTagList.splice(
        this.formData.storeTagList.indexOf(tag),
        1,
      );
    },
    showTagInput() {
      this.tagInputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleTagInputConfirm() {
      if (this.formData.storeTagList.length >= 5) {
        this.$message.error("标签不能超过5个");
        return;
      }
      let inputValue = this.tagInputValue;
      if (inputValue) {
        this.formData.storeTagList.push(inputValue);
      }
      this.tagInputVisible = false;
      this.tagInputValue = "";
    },
    submitFun() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.formData.id) {
            editStoreAPI({
              ...this.formData,
              districtId: this.formData.regionIdList[2],
            }).then(() => {
              this.$message.success("编辑成功");
              this.$emit("closeDialog", true);
            });
          } else {
            addStoreAPI({
              ...this.formData,
              districtId: this.formData.regionIdList[2],
            }).then(() => {
              this.$message.success("新增成功");
              this.$emit("closeDialog", true);
            });
          }
        }
      });
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
}

.store-dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 20px 24px;
    border-bottom: none;

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__close {
      color: #fff;
      font-size: 20px;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 24px;
    background: #f5f7fa;
  }

  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid #e4e7ed;
  }

  ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #606266;
    font-size: 14px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}

.scroll-wrap {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

.store-form {
  .form-section {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .section-title {
      background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
      padding: 14px 20px;
      border-bottom: 2px solid #e4e7ed;
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: 600;
      color: #303133;

      i {
        margin-right: 8px;
        font-size: 16px;
        color: #667eea;
      }
    }

    .section-content {
      padding: 20px 24px;
    }
  }

  .form-input {
    width: 100%;
    max-width: 400px;

    ::v-deep .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #667eea;
        box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  .form-textarea {
    width: 100%;
    max-width: 500px;

    ::v-deep .el-textarea__inner {
      border-radius: 4px;
      transition: all 0.3s ease;
      resize: vertical;

      &:focus {
        border-color: #667eea;
        box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  ::v-deep .el-select {
    width: 100%;
    max-width: 400px;

    .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #667eea;
        box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  ::v-deep .el-input-number {
    width: 100%;
    max-width: 400px;

    .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #667eea;
        box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
      }
    }
  }

  ::v-deep .el-cascader {
    width: 100%;
    max-width: 400px;

    .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #667eea;
        box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  // 门店标签样式
  .store-tags {
    width: 100%;
    max-width: 500px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 8px;
    background: #fafbfc;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    transition: all 0.3s ease;

    &:hover {
      border-color: #c0c4cc;
    }

    .store-tag-item {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #fff;
      border: none;
      border-radius: 12px;
      padding: 4px 12px;
      font-size: 12px;
      font-weight: 500;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 6px rgba(102, 126, 234, 0.3);
      }

      ::v-deep .el-icon-close {
        color: #fff;

        &:hover {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }

    .button-new-tag {
      margin-left: 0;
      height: 28px;
      line-height: 26px;
      padding: 0 12px;
      border: 1px dashed #c0c4cc;
      border-radius: 4px;
      color: #606266;
      background: #fff;
      transition: all 0.3s ease;

      &:hover {
        border-color: #667eea;
        color: #667eea;
        background: #ecf5ff;
      }
    }

    .input-new-tag {
      width: 120px;
      margin-left: 0;

      ::v-deep .el-input__inner {
        border-radius: 4px;
        transition: all 0.3s ease;

        &:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
        }
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .el-button {
    padding: 10px 24px;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.3s ease;

    &.el-button--primary {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border: none;

      &:hover {
        opacity: 0.9;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
      }
    }

    &:not(.el-button--primary) {
      &:hover {
        color: #667eea;
        border-color: #667eea;
        background-color: #ecf5ff;
      }
    }
  }
}

// 文件上传组件样式
.wrapper ::v-deep {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      border-color: #667eea;
      background: #f5f7fa;
  }
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }

  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .store-dialog {
    ::v-deep .el-dialog {
      width: 95% !important;
      margin: 5vh auto;
    }
  }

  .form-input,
  .form-textarea {
    max-width: 100% !important;
  }

  .store-tags {
    max-width: 100% !important;
  }
}
</style>
